import './instrument'   // Sentry init — MUST be first
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './auth/auth.css'
import App from './App.tsx'
import { ErrorBoundary } from './components/ErrorBoundary.tsx'
import { AuthProvider } from './auth/AuthProvider.tsx'
import AuthCallback from './auth/AuthCallback.tsx'
import Pricing from './pages/Pricing.tsx'
import Billing from './pages/Billing.tsx'
import CvCadLogin from './pages/CvCadLogin.tsx'

// Route shim — cv-web is a single-page app today; these few /paths are the
// only ones we need to differentiate without pulling in a router dep.
// Strip the Vite base prefix ('/cv-web/' in production, '/' in dev) before
// matching so the same checks work locally and on simplestruct.com.
function routedApp() {
  const base = import.meta.env.BASE_URL.replace(/\/+$/, '');
  let path = window.location.pathname;
  if (base && path.startsWith(base)) path = path.slice(base.length);
  if (!path.startsWith('/')) path = '/' + path;

  if (path === '/auth/callback' || path.startsWith('/auth/callback/')) return <AuthCallback />;
  // Document-style routes need to scroll — body has overflow:hidden for the SPA.
  if (path === '/pricing'       || path.startsWith('/pricing/'))       return <div className="doc-scroll"><Pricing /></div>;
  if (path === '/billing'       || path.startsWith('/billing/'))       return <div className="doc-scroll"><Billing /></div>;
  if (path === '/cv-cad-login'  || path.startsWith('/cv-cad-login/'))  return <div className="doc-scroll"><CvCadLogin /></div>;
  return <App />;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        {routedApp()}
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>,
)
